import React from 'react';

import FileExplorer from 'components/FileViewer';

export default function FileViewer() {
  return <FileExplorer />;
}
